<template>
    <div>
        <div class="flex-container" id="main_nav" style="background:#939393;">
            <div class="c1">
                <div><svg @click="openMobileSidebar" width="34px" height="34px" viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg" fill="none">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                            <path stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M4 6H20M4 12H20M4 18H20"></path>
                        </g>
                    </svg> </div>

                <img src="@/assets/images/logo-sidebar.png" alt="Logo" />
            </div>
            <div style="flex: 1;"></div>
            <div v-if="user.token != ''" class="c3">
                <div style="cursor:pointer;" class="px-2 pe-2 text-center nav-item dropdown">
                    <language-selector v-bind:skin="skin" v-bind:language="language" />
                </div>
                <div class="dropdown mx-1" style="font-family: 'poppins';">
                        <button class="btn btn-dark dropdown-toggle border-radiu btn-sm" type="button"
                            data-bs-toggle="dropdown" aria-expanded="false" style="border-radius:10px">
                            <span style="font-weight:800"> {{ user.user_data.data ?
                                user.user_data.data.user_name : '' }}</span>
                            <br>
                    <span @click="showBalanceAction" style="color:white;">
                        {{ user.user_data.data ? new Intl.NumberFormat("de-DE", {
                            minimumFractionDigits: skin.qBet_config.decimalsQty,
                            maximumFractionDigits: skin.qBet_config.decimalsQty
                        }).format(balance.saldo) : 0 }}
                    </span> 
                            
                        </button>
                        <ul class="dropdown-menu dropdown-menu-lg-end">
                            <li><a v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.userMenu.loginHistory"
                                    data-bs-toggle="modal" data-bs-target="#historial_ingresos" class="dropdown-item"
                                    href="#"><i class="fa fa-database"></i> {{ translate('option_user') }}</a></li>
                            <li><a v-if="skin.my_account.myaccount_type == 'JM' && skin.header_desktop.userMenu.changePassword"
                                    id="changePasswordBtn" data-bs-toggle="modal" data-bs-target="#changePasswordJm"
                                    class="dropdown-item" href="#"><i class="fa fa-key"></i>
                                    {{ translate('change_password') }}</a></li>
                            <li><a v-if="skin.header_desktop.userMenu.balanceHistory" @click="getMovements()"
                                    data-bs-toggle="modal" data-bs-target="#myAccountZeus" class="dropdown-item"
                                    href="#"><i class="fa fa-history"></i> {{ translate('account_history') }}</a></li>
                            <li><a v-if="skin.header_desktop.userMenu.sportsRules" @click="terms" class="dropdown-item"
                                    href="#"><i class="fa fa-book"></i> {{ translate('regulations') }}</a></li>
                            <li><a v-if="skin.logout" @click="logout" class="dropdown-item" href="#"><i
                                        class="fa fa-power-off"></i> {{ translate('go_out') }}</a></li>
                        </ul>

                    </div>
            </div>
            <div v-if="user.token == ''" class="c4">
                <div style="cursor:pointer;" class="px-2 pe-2 text-center nav-item dropdown">
                    <language-selector v-bind:skin="skin" v-bind:language="language" />
                </div>
                <div v-if="skin.login" @click="login" class="style" style="background:black;color:white;">
                    {{ translate('log_in') }}
                </div>
            </div>
            
            <button id="login_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#login"
                style="display:none;"></button>
            <login v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <changePassword v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <misDatos v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <myAccountZeus v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
        </div>
        <div v-if="isMobileSidebarOpen" class="backblur" @click="closeMobileSidebar"></div>
        <div :class="['mobile-sidebar', { open: isMobileSidebarOpen }]">
            <div class="casino_menu_providers" style="padding: 0 !important;">
                <div class="casino_menu_categoryes_head">Lobby</div>
                <div v-for="(item, index) in getCategoriesByType('lobby')" :key="item.url" @click="change_view(item.url)"
                    style="display:grid;grid-template-columns: 10% 90%;padding:11px 10px;font-size: 13px;font-weight: 700;">
                    <p style="margin-bottom: 0;">&#9679;</p>
                    <span>{{ translate(item.name) }} </span>
                </div>
                <div class="casino_menu_categoryes_head">Deportes</div>
                <div v-for="(item, index) in getCategoriesByType('sport')" :key="item.url" @click="change_view(item.url)"
                    style="display:grid;grid-template-columns: 10% 90%;padding:11px 10px;font-size: 13px;font-weight: 700;">
                    <p style="margin-bottom: 0;">&#9679;</p>
                    <span>{{ translate(item.name) }} </span>
                </div>
                <div class="casino_menu_categoryes_head">Casino</div>
                <div v-for="(item, index) in getCategoriesByType('casino')" :key="item.url" @click="change_view(item.url)"
                    style="display:grid;grid-template-columns: 10% 90%;padding:11px 10px;font-size: 13px;font-weight: 700;">
                    <p style="margin-bottom: 0;">&#9679;</p>
                    <span>{{ translate(item.name) }} </span>
                </div>
                <div class="casino_menu_categoryes_head">Casino en vivo</div>
                <div v-for="(item, index) in getCategoriesByType('casino_live')" :key="item.url" @click="change_view(item.url)"
                    style="display:grid;grid-template-columns: 10% 90%;padding:11px 10px;font-size: 13px;font-weight: 700;">
                    <p style="margin-bottom: 0;">&#9679;</p>
                    <span>{{ translate(item.name) }} </span>
                </div>
                <div class="casino_menu_categoryes_head">Paneles</div>
                <div v-for="(item, index) in getCategoriesByType('admin')" :key="item.url" @click="change_view(item.url)"
                    style="display:grid;grid-template-columns: 10% 90%;padding:11px 10px;font-size: 13px;font-weight: 700;">
                    <p style="margin-bottom: 0;">&#9679;</p>
                    <span>{{ translate(item.name) }} </span>
                </div>
                <div class="casino_menu_categoryes_head">Páginas Completas</div>
                <div v-for="(item, index) in getCategoriesByType('webs')" :key="item.url"
                    style="display:grid; grid-template-columns: 10% 90%; padding:11px 10px; font-size: 13px; font-weight: 700;">
                    <p style="margin-bottom: 0;">&#9679;</p>
                    <a :href="item.url" target="_blank" style="text-decoration: none; color: inherit;">
                        {{ translate(item.name) }}
                    </a>
                </div>


            </div>
        </div>
    </div>
</template>
<script>
import login from "../zeus/header/login.vue";
import languageSelector from "../zeus/header/language.vue";
import changePassword from "../zeus/header/changePassword.vue";
import misDatos from "../zeus/header/mis_datos.vue";
import myAccountZeus from "../zeus/header/my_account.vue"
export default {
    name: 'MainPortafolio',
    props: ['skin', 'language', 'translation'],
    data() {
        return {
            isMobileSidebarOpen: false,
            showBalance: false,
            balance: {
                saldo: 0,
                conversion: 0,
                view: "SALDO",
                switch: 1
            }
        };
    },
    components: {
        login,
        languageSelector,
        changePassword,
        misDatos,
        myAccountZeus
    },
    methods: {
        logout() {
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
        },
        terms() {
            let url = "";
            let lang = this.$props.language == 'es' ? 'spa' : (this.$props.language == 'en' ? 'eng' : (this.$props.language == 'pt' ? 'pt-br' : 'spa'));
            if (this.user.prefix == "external") {
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + this.user.site.toUpperCase() + "&link=" + this.user.site;
            }
            else {
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1] + '.' + domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + domain_name1 + "&link=" + domain_name2;
            }

            window.open(url, '_blank').focus();
        },
         getMovements() {
            this.$root.$emit('getMovementsHistory');
        },
        showBalanceAction() {
            if (!this.showBalance) {
                this.$store.dispatch('getProfile', {
                    token: this.user.token,
                    site_id: this.user.site_id,
                    site: this.user.site,
                    prefix: this.user.prefix,
                    playerId: this.user.user_data?.data?.user_id,
                    source: "main"
                });
                this.showBalance = true
            }
            else {
                this.showBalance = false
            }
        },
        change_view(viewUrl) {
    // Encuentra el índice del objeto cuyo URL coincide exactamente con el que envías
    const index = this.skin.categories.findIndex(category => category.url === viewUrl);

    if (index !== -1) {
        this.$store.dispatch("changeView", index);
    } else {
        console.warn("URL no encontrada en las categorías:", viewUrl);
    }

    this.isMobileSidebarOpen = false;
},
        openMobileSidebar() {
            this.isMobileSidebarOpen = true;
        },
        closeMobileSidebar() {
            this.isMobileSidebarOpen = false;
        },
        login() {
            document.getElementById('login_btn').click();
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
        getCategoriesByType(type) {
            return this.skin.categories.filter(cat => cat.active && cat.category === type);
        }

    },
    computed: {
        user() {
            let data = this.$store.getters['getUserData'];
            if (data.user_data.data) {
                this.balance.saldo = data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
                this.userDataLoaded = true;
            }
            return data;
        }
    },
    mounted() {
        this.$store.dispatch("setHeaderHeight", document.getElementById("main_nav").offsetHeight);
        this.$root.$on('openLogin', () => {
            this.login();
        });
    },
     created() {
        const self = this;
        let balanceRequestTime = 8000;

        var saldo_request = setInterval(function () {
            try {
                if (self.user.user_data.data && self.user.token != '') {
                    self.$store.dispatch('getProfile', {
                        token: self.user.token,
                        site_id: self.user.site_id,
                        site: self.user.site,
                        prefix: self.user.prefix,
                        playerId: self.user.user_data?.data?.user_id,
                        source: "main"
                    });
                }
            } catch (error) {
                this.$store.dispatch('logOut');
                clearInterval(saldo_request);
            }
        }, balanceRequestTime);
    },
    beforeDestroy() {
        this.$root.$off('openLogin');
    }
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap');

.flex-container {
    display: flex;
    justify-content: space-between;
    height: 65px;
    padding: 12.25px 10px;
}


.c1 img {
    max-width: 100%;
    /* Asegura que la imagen no se desborde horizontalmente */
    max-height: 100%;
    /* Asegura que la imagen no se desborde verticalmente */
    object-fit: contain;
    /* Ajusta la imagen dentro del contenedor sin distorsión */
}

.c1 {
    display: flex;
    align-items: center;
    gap: 5px;
    justify-content: flex-start;
}

@media (max-width: 768px) {
    .c1 svg {
        max-width: 25px;
        /* Ajusta el tamaño de la imagen en pantallas pequeñas */
    }
}

.c4 {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.c3 {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.casino_menu_providers {
    padding: 10px 0;
    font-family: 'poppins';
}

.casino_menu_categoryes_head {
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
    color: var(--hide_color);
    margin: 15px 10px;
}
.casino_menu_providers div{
    user-select: none;
    cursor: pointer;
}
.backblur {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    /* backdrop-filter: blur(0px) brightness(100%); */
    animation: backblur_animation 0.3s linear;
    animation-fill-mode: forwards;
}

@keyframes backblur_animation {
    0% {
        backdrop-filter: blur(0px) brightness(100%);
    }

    100% {
        backdrop-filter: blur(7px) brightness(115%);
    }
}

.mobile-sidebar {
    position: fixed;
    color: #fff;
    top: 0;
    left: 0;
    width: 250px;
    height: 100%;
    background-color: #000000;
    z-index: 50;
    overflow-y: auto;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.3);
    transform: translateX(-100%);
    transition: transform 0.3s ease;
}

.mobile-sidebar.open {
    transform: translateX(0);
}

.style {
    display: flex;
    font-family: "Poppins", sans-serif;
    font-size: 12.25px;
    padding: 0 14px;
    border-radius: 11.2px;
    height: 100%;
    margin-right: 13px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    user-select: none;
}

.style:hover {
    transform: scale(1.1);
    /* Aumenta ligeramente el tamaño */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.3);
    /* Sombra suave */
}
</style>